module.exports = ".col-xl-6 {\n  margin-left: auto;\n  margin-right: auto; }\n"